<template>
    <button v-on:click="clocking()" :style="{'background-color': canClock ? '#3c41e9' : '#979DA6','cursor':(!canClock || isLoad) ? 'not-allowed' : 'pointer'}" :disabled="(!canClock || isLoad)" class="text-white rounded-lg h-[36px] w-[130px] flex items-center justify-center">
          <Loader2 v-if="isLoad" class="animate-spin text-white"/>
          <Target v-if="!isLoad" color="#ffffff" :size="16" strokeWidth="1.3"/>
          <span class="ml-[6px]">{{ lastclock == 0 ? "Clock in" : "Clock out" }}</span>
    </button>
</template>
<script>
import {Loader2,Target} from "lucide-vue-next"
import API from '@/service/API';
import Swal from 'sweetalert2';
import { formatDate } from "@/utils/date-format";
export default {
    name: "ClockComponent",
    components:{
        Loader2,
        Target,
    },
    data(){
        return {
            lastclock:0,
            canClock: false,
            isLoad:false,
        }
    },
    mounted(){
        this.fetchUserInfo();
    },
    methods:{
        fetchUserInfo(){
            this.isLoad = true;
            API.get("/fetchUser/"+(localStorage.getItem("userId") ?? this.$store.getters.userId))
            .then((response)=>{
                this.canClock = response.data["canclock"];
                this.lastclock = response.data["lastclock"]["state"];
            })
            .catch((error) => {console.error(error)})
            .finally(()=>{this.isLoad = false;})
        },
        clock(position){
            const {latitude,longitude} = position;
            API.post("clockInOut",{
                'date': formatDate(),
                'lat': latitude,
                'lon': longitude,
            })
            .then(response=>{
                if(!response.data.status) throw Error(response.data?.message ?? "Erreur survenue durant l'opération, merci de contacter l'administrateur");
                // this.fetchUserInfo();
                Swal.fire('Success',"Action enregistrer",'success');
            })
            .catch((e)=> Swal.fire('Erreur',e.message,'error'))
            .finally(()=>{this.isLoad = false;})
        },
        clockError(error){
            let errorMessage = "";
            switch(error.code) {
                case error.PERMISSION_DENIED:
                    errorMessage = "L'utilisateur a refusé la demande de géolocalisation.";
                    break;
                case error.POSITION_UNAVAILABLE:
                    errorMessage = "Les informations de localisation ne sont pas disponibles.";
                    break;
                case error.TIMEOUT:
                    errorMessage = "La demande de localisation a expiré.";
                    break;
                case error.UNKNOWN_ERROR:
                    errorMessage = "Une erreur inconnue est survenue.";
                    break;
            }
            this.isLoad = false;
            Swal.fire('Erreur',errorMessage,'error');
        },
        clocking(){
            this.isLoad = true;
            if (navigator.geolocation){
                navigator.geolocation.getCurrentPosition(this.clock,this.clockError,{
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 0
                    });
            }
            else{
                Swal.fire('Erreur',"La géolocalisation n'est pas supportée par ce navigateur.",'error');
            }
        },
    }
}
</script>